import { Container } from '../../odie';

import { app } from '../app';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { ParticleEmitter } from '../particles/ParticleEmitter';
import { tweenPower2In } from '../../lib/util/tweens';

// types
//-----------------------------------------------------------------------------
export type ScatteringBeesAnimationOptions = {
  asset: string;
  amount?: number;
};

/*
    bees scattering animation
*/
export class ScatteringBeesAnimation extends Container implements IAnimation {
  // fields
  //-------------------------------------------------------------------------
  private _options: ScatteringBeesAnimationOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(options: ScatteringBeesAnimationOptions) {
    super();
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public async start(): Promise<void> {
    // create bee emitter
    const beeEmitter = this._createBeeEmitter();

    // animate bees
    await this._animateBees(beeEmitter);
  }

  public stop() {}

  // private: animators
  //-------------------------------------------------------------------------
  private async _animateBees(bees: ParticleEmitter) {
    // spawn bees
    this.addChild(bees.view);

    // start
    await bees.start();

    // despawn bees
    this.removeChild(bees.view);
  }

  // private: factory
  //-------------------------------------------------------------------------
  private _createBeeEmitter(): ParticleEmitter {
    return app.particles.create({
      textures: [this._options.asset],
      rate: 0,
      limit: this._options.amount ?? 5,
      emitterDuration: 0,
      duration: 1,
      behaviors: [
        {
          type: 'explode',
          magnitude: [250, 500],
          applyRotation: true,
          rotationOffset: Math.PI * 0.5,
        },
        { type: 'scale', to: 1.5 },
        { type: 'fade', to: 0, tween: tweenPower2In },
        { type: 'kinematic' },
      ],
    });
  }
}
